import EditProductPage from './edit-product-page';

export default EditProductPage;